import {Component, OnInit} from '@angular/core';
import {AppeloffreService} from 'src/app/modules/services/appel-offre/appeloffre.service';

@Component({
    selector: 'app-tous-les-statistiques',
    templateUrl: './tous-les-statistiques.component.html',
    styleUrls: ['./tous-les-statistiques.component.css']
})
export class TousLesStatistiquesComponent implements OnInit {

    constructor(private offservice: AppeloffreService) {
    }

    ngOnInit(): void {
    }

    telecharger() {
        this.offservice.findPendingInwardsPdf().subscribe((response) => {
            const file = new Blob([response as unknown as BlobPart], {type: 'application/pdf'});
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL);
        });
    }
}
